import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-privacy',
	templateUrl: 'privacy.component.html',
})
export class PrivacyComponent implements OnInit, OnDestroy {
	currentLang: string = 'es';
	privacyData: any = null;
	private routeSub: Subscription;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private http: HttpClient
	) {}

	ngOnInit() {
		this.routeSub = this.route.params.subscribe((params: Params) => {
			const lang = params['lang'];
			const supportedLangs = ['es', 'en', 'pl', 'pt', 'zh'];
			if (lang && supportedLangs.indexOf(lang) > -1) {
				this.currentLang = lang;
			} else {
				this.currentLang = 'es';
			}
			this.loadPrivacyData();
		});
	}

	loadPrivacyData() {
		this.http.get(`assets/i18n/privacy/${this.currentLang}.json`).subscribe(
			(data) => {
				this.privacyData = data;
			},
			(error) => {
				console.error('Error loading privacy data:', error);
				// Fallback to es.json if failed to load
				if (this.currentLang !== 'es') {
					this.currentLang = 'es';
					this.loadPrivacyData();
				}
			}
		);
	}

	ngOnDestroy() {
		if (this.routeSub) {
			this.routeSub.unsubscribe();
		}
	}

	changeLanguage(lang: string) {
		this.router.navigate(['/privacy', lang]);
	}
}
